export * from './lib/shared-favorites.module';
export * from './lib/favorites-list/favorites-list.component';
export * from './lib/services/favorites-service.service';
